import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type InstallState =
  | "idle"
  | "eligible"
  | "prompting"
  | "installed"
  | "dismissed"
  | "unsupported";

export type InstallSliceState = {
  state: InstallState;
  error: boolean;
  eligible: boolean;
  triggers: {
    declinePushLike: boolean;
    viewModels: number[];
    sparks: boolean;
    banner: boolean;
  };
};

const initialState: InstallSliceState = {
  state: "idle",
  error: false,
  eligible: false, // true if the user is eligible for the pwa install
  triggers: {
    declinePushLike: false,
    viewModels: [],
    sparks: false,
    banner: false,
  },
};

const pwaSlice = createSlice({
  name: "pwa",
  initialState,
  reducers: {
    setState(
      state,
      {
        payload,
      }: PayloadAction<
        InstallState | { state: InstallState; eligible?: boolean }
      >
    ) {
      if (typeof payload === "string") {
        state.state = payload;
        state.error = false;

        if (payload === "eligible") {
          state.eligible = true;
        }
      } else {
        state.state = payload.state;
        state.error = false;

        if (typeof payload.eligible === "boolean") {
          state.eligible = payload.eligible;
        }
      }
    },
    setError(state, { payload }: PayloadAction<boolean>) {
      state.error = payload;
    },
    setTrigger(
      state,
      { payload }: PayloadAction<Partial<InstallSliceState["triggers"]>>
    ) {
      state.triggers = {
        ...state.triggers,
        ...payload,
      };
    },
  },
});

export const { setState, setError, setTrigger } = pwaSlice.actions;

export default pwaSlice.reducer;
